import TicketPicker from "../TicketPicker";
import parse from "html-react-parser";
function MainContent(props){
  const content = props.content;
  console.log(content)
    return(
        <>
        <div className="container container--paddings plan-view__container astro-vobjiul6">
      <div className="flex flex--wrap astro-vobjiul6">
        <div className="plan-content astro-tsqtnjzv" data-testid="plan-content">
          <div className="plan-content__hero-info astro-tsqtnjzv">
            <div
              id="plan-hero-info-wrapper"
              className="plan-hero__info-wrapper astro-puoy2ru4"
            >
              <div className="plan-hero__labels astro-puoy2ru4">
                {" "}
                <span
                  className="label astro-puoy2ru4 astro-hwfomf7x"
                  style={{ color: "#ffffff", backgroundColor: "#6f41d7" }}
                  data-testid="plan-custom-label-undefined"
                >
                  {" "}
                  Exklusiv von Fever{" "}
                </span>{" "}
                <span
                  className="label label--warning astro-puoy2ru4 astro-hwfomf7x"
                  style={{}}
                  data-testid="plan-custom-label-warning"
                >
                  {" "}
                  Die Tickets gehen langsam aus{" "}
                </span>{" "}
              </div>
              {/* TODO: resolve plan name with A/B test */}
              <h1
                className="plan-hero__title astro-puoy2ru4"
                data-testid="plan-name"
              >
                {content?content.description:""}
              </h1>
              <div className="plan-hero__rating plan-hero__rating--outside-image mb-8 astro-puoy2ru4">
                <div className="fv-rating  svelte-1fudi3b">
                  <div className="fv-rating__average svelte-1fudi3b">4.3</div>{" "}
                  <span className="fv-rating__stars svelte-1fudi3b fv-rating__stars--average">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      aria-hidden="true"
                      focusable="false"
                      className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                      viewBox="0 0 576 512"
                    >
                      <path
                        fill="currentColor"
                        d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                      ></path>
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      aria-hidden="true"
                      focusable="false"
                      className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                      viewBox="0 0 576 512"
                    >
                      <path
                        fill="currentColor"
                        d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                      ></path>
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      aria-hidden="true"
                      focusable="false"
                      className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                      viewBox="0 0 576 512"
                    >
                      <path
                        fill="currentColor"
                        d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                      ></path>
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      aria-hidden="true"
                      focusable="false"
                      className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                      viewBox="0 0 576 512"
                    >
                      <path
                        fill="currentColor"
                        d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                      ></path>
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      aria-hidden="true"
                      focusable="false"
                      className="svg-inline--fa fa-star-half-stroke fv-rating__star svelte-1ipid5s"
                      viewBox="0 0 640 512"
                    >
                      <path
                        fill="currentColor"
                        d="M320 376.4l.1-.1 26.4 14.1 85.2 45.5-16.5-97.6-4.8-28.7 20.7-20.5 70.1-69.3-96.1-14.2-29.3-4.3-12.9-26.6L320.1 86.9l-.1 .3V376.4zm175.1 98.3c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3L320.1 439.8 191.8 508.3C181 514 167.9 513.1 158 506s-14.9-19.3-12.9-31.3L169.8 329 65.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L227 150.3 291.4 18c5.4-11 16.5-18 28.8-18s23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L470.5 329l24.6 145.7z"
                      ></path>
                    </svg>
                  </span>{" "}
                  <span className="fv-rating__amount svelte-1fudi3b">
                    (863)
                  </span>
                </div>
              </div>
              <div className="plan-hero__actions astro-puoy2ru4">
                <div className="plan-hero__actions-favorite astro-puoy2ru4"></div>
              </div>
              <hr className="astro-puoy2ru4" />
            </div>
          </div>
          {/* Description */}
          <div
            id="plan-description"
            className="plan-description astro-mcijlqbj"
            data-testid="plan-content-description"
          >
            {
              parse(content?content.description:"")
            }
          </div>
          <section className="plan-content__block svelte-b3darg">
            <h2 className="plan-content__block-title svelte-1w2y8p7">
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                role="img"
                aria-hidden="true"
                focusable="false"
                className="svg-inline--fa fa-star-half-stroke astro-2srdwj4y svelte-1ipid5s"
                viewBox="0 0 640 512"
              >
                <path
                  fill="currentColor"
                  d="M234.4 186.5L97 206.8l99.8 98.8c7.4 7.3 10.8 17.8 9 28.1L182.2 473.2 304 408.1V75.1l-45.5 93.7c-4.6 9.5-13.6 16.1-24.1 17.7zM336 408.2l121.6 65L434.1 333.7c-1.7-10.3 1.6-20.7 9-28.1l99.8-98.8L405.4 186.5c-10.5-1.5-19.5-8.2-24.1-17.7L336 75.4V408.2zm146.2 99.2c-7.4 5.3-17.3 6-25.3 1.7l-137-73.2L183 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L63.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L298.3 13.5C302.4 5.2 310.7 0 319.9 0s17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L465.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5z"
                ></path>
              </svg>{" "}
              Đánh giá của người dùng{" "}
            </h2>
            <div
              className="plan-user-reviews astro-2srdwj4y"
              data-testid="plan-user-reviews"
            >
              <div className="plan-user-reviews__summary astro-2srdwj4y">
                <div
                  className="average astro-2srdwj4y"
                  data-testid="plan-user-reviews-average"
                >
                  {" "}
                  4.27 <span className="average__over astro-2srdwj4y">
                    /5
                  </span>{" "}
                </div>
                <div className="average-wrapper astro-2srdwj4y">
                  <div className="fv-rating  svelte-1fudi3b">
                    {" "}
                    <span className="fv-rating__stars svelte-1fudi3b">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        role="img"
                        aria-hidden="true"
                        focusable="false"
                        className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                        viewBox="0 0 576 512"
                      >
                        <path
                          fill="currentColor"
                          d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                        ></path>
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        role="img"
                        aria-hidden="true"
                        focusable="false"
                        className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                        viewBox="0 0 576 512"
                      >
                        <path
                          fill="currentColor"
                          d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                        ></path>
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        role="img"
                        aria-hidden="true"
                        focusable="false"
                        className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                        viewBox="0 0 576 512"
                      >
                        <path
                          fill="currentColor"
                          d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                        ></path>
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        role="img"
                        aria-hidden="true"
                        focusable="false"
                        className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                        viewBox="0 0 576 512"
                      >
                        <path
                          fill="currentColor"
                          d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                        ></path>
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        role="img"
                        aria-hidden="true"
                        focusable="false"
                        className="svg-inline--fa fa-star-half-stroke fv-rating__star svelte-1ipid5s"
                        viewBox="0 0 640 512"
                      >
                        <path
                          fill="currentColor"
                          d="M320 376.4l.1-.1 26.4 14.1 85.2 45.5-16.5-97.6-4.8-28.7 20.7-20.5 70.1-69.3-96.1-14.2-29.3-4.3-12.9-26.6L320.1 86.9l-.1 .3V376.4zm175.1 98.3c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3L320.1 439.8 191.8 508.3C181 514 167.9 513.1 158 506s-14.9-19.3-12.9-31.3L169.8 329 65.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L227 150.3 291.4 18c5.4-11 16.5-18 28.8-18s23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L470.5 329l24.6 145.7z"
                        ></path>
                      </svg>
                    </span>{" "}
                  </div>
                  <div
                    className="average-wrapper__info astro-2srdwj4y"
                    data-testid="plan-user-reviews-number-of-ratings"
                  >
                    Basierend auf 863 Bewertungen{" "}
                  </div>
                </div>
              </div>
              <ul className="plan-user-reviews__list astro-2srdwj4y">
                <li
                  className="plan-user-reviews__item astro-2srdwj4y"
                  data-testid="plan-user-reviews-item"
                >
                  <div className="item-wrapper mb-8 astro-2srdwj4y">
                    <div className="user-info astro-2srdwj4y">
                      <div className="name astro-2srdwj4y">Anh Bảiii</div>
                      <div className="date astro-2srdwj4y">Dec 2024</div>
                    </div>
                    <div className="rating_item astro-2srdwj4y">
                      <div className="fv-rating  svelte-1fudi3b">
                        {" "}
                        <span className="fv-rating__stars svelte-1fudi3b">
                          {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg> */}
                          {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg> */}
                          {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg> */}
                          {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg> */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                        </span>{" "}
                      </div>
                    </div>
                  </div>
                  <div className="reason astro-2srdwj4y">
                    Web xấu quá.
                  </div>
                </li>
                <li
                  className="plan-user-reviews__item astro-2srdwj4y"
                  data-testid="plan-user-reviews-item"
                >
                  <div className="item-wrapper mb-8 astro-2srdwj4y">
                    <div className="user-info astro-2srdwj4y">
                      <div className="name astro-2srdwj4y">A Hiếu Già</div>
                      <div className="date astro-2srdwj4y">Dec 2024</div>
                    </div>
                    <div className="rating_item astro-2srdwj4y">
                      <div className="fv-rating  svelte-1fudi3b">
                        {" "}
                        <span className="fv-rating__stars svelte-1fudi3b">
                          {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg> */}
                          {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg> */}
                          {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg> */}
                          {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg> */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                        </span>{" "}
                      </div>
                    </div>
                  </div>
                  <div className="reason astro-2srdwj4y">
                    Không thể chấp nhận web xấu như thế này
                  </div>
                </li>
                <li
                  className="plan-user-reviews__item astro-2srdwj4y"
                  data-testid="plan-user-reviews-item"
                >
                  <div className="item-wrapper mb-8 astro-2srdwj4y">
                    <div className="user-info astro-2srdwj4y">
                      <div className="name astro-2srdwj4y">Em Tín</div>
                      <div className="date astro-2srdwj4y">Dec 2024</div>
                    </div>
                    <div className="rating_item astro-2srdwj4y">
                      <div className="fv-rating  svelte-1fudi3b">
                        {" "}
                        <span className="fv-rating__stars svelte-1fudi3b">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                        </span>{" "}
                      </div>
                    </div>
                  </div>
                  <div className="reason astro-2srdwj4y">
                   Tôi chưa bao giờ thấy web nào đẹp như thế này
                  </div>
                </li>
                <li
                  className="plan-user-reviews__item astro-2srdwj4y"
                  data-testid="plan-user-reviews-item"
                >
                  <div className="item-wrapper mb-8 astro-2srdwj4y">
                    <div className="user-info astro-2srdwj4y">
                      <div className="name astro-2srdwj4y">Beate F.</div>
                      <div className="date astro-2srdwj4y">Dez. 2024</div>
                    </div>
                    <div className="rating_item astro-2srdwj4y">
                      <div className="fv-rating  svelte-1fudi3b">
                        {" "}
                        <span className="fv-rating__stars svelte-1fudi3b">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                        </span>{" "}
                      </div>
                    </div>
                  </div>
                  <div className="reason astro-2srdwj4y">
                    Sehr schön großzügig aufgebaut, so dass die einzelnen
                    Kunstwerke gut wirken und auch von allen Seiten betrachtet
                    werden können.
                  </div>
                </li>
                <li
                  className="plan-user-reviews__item astro-2srdwj4y"
                  data-testid="plan-user-reviews-item"
                >
                  <div className="item-wrapper mb-8 astro-2srdwj4y">
                    <div className="user-info astro-2srdwj4y">
                      <div className="name astro-2srdwj4y">Hans B.</div>
                      <div className="date astro-2srdwj4y">Dez. 2024</div>
                    </div>
                    <div className="rating_item astro-2srdwj4y">
                      <div className="fv-rating  svelte-1fudi3b">
                        {" "}
                        <span className="fv-rating__stars svelte-1fudi3b">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                        </span>{" "}
                      </div>
                    </div>
                  </div>
                  <div className="reason astro-2srdwj4y">
                    Mehr Werbung hätte die Ausstellung verdient, da sie sehr
                    viele tolle Exponate hat.
                  </div>
                </li>
                <li
                  className="plan-user-reviews__item astro-2srdwj4y"
                  data-testid="plan-user-reviews-item"
                >
                  <div className="item-wrapper mb-8 astro-2srdwj4y">
                    <div className="user-info astro-2srdwj4y">
                      <div className="name astro-2srdwj4y">R B.</div>
                      <div className="date astro-2srdwj4y">Dez. 2024</div>
                    </div>
                    <div className="rating_item astro-2srdwj4y">
                      <div className="fv-rating  svelte-1fudi3b">
                        {" "}
                        <span className="fv-rating__stars svelte-1fudi3b">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                        </span>{" "}
                      </div>
                    </div>
                  </div>
                  <div className="reason astro-2srdwj4y">
                    Eine absolut sehenswerte und interessante Ausstellung. Die
                    Figuren sind 🤘
                  </div>
                </li>
                <li
                  className="plan-user-reviews__item astro-2srdwj4y"
                  data-testid="plan-user-reviews-item"
                >
                  <div className="item-wrapper mb-8 astro-2srdwj4y">
                    <div className="user-info astro-2srdwj4y">
                      <div className="name astro-2srdwj4y">Nadja S.</div>
                      <div className="date astro-2srdwj4y">Dez. 2024</div>
                    </div>
                    <div className="rating_item astro-2srdwj4y">
                      <div className="fv-rating  svelte-1fudi3b">
                        {" "}
                        <span className="fv-rating__stars svelte-1fudi3b">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                        </span>{" "}
                      </div>
                    </div>
                  </div>
                  <div className="reason astro-2srdwj4y">
                    Wirklich schöne kurzweilige Ausstellung. Man erhält einen
                    guten Zugang zum Künstler durch einige Videoinstallationen
                    und den kurzen Begleittexten zu jedem Werk.
                  </div>
                </li>
                <li
                  className="plan-user-reviews__item astro-2srdwj4y"
                  data-testid="plan-user-reviews-item"
                >
                  <div className="item-wrapper mb-8 astro-2srdwj4y">
                    <div className="user-info astro-2srdwj4y">
                      <div className="name astro-2srdwj4y">Michaela O.</div>
                      <div className="date astro-2srdwj4y">Dez. 2024</div>
                    </div>
                    <div className="rating_item astro-2srdwj4y">
                      <div className="fv-rating  svelte-1fudi3b">
                        {" "}
                        <span className="fv-rating__stars svelte-1fudi3b">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                            aria-hidden="true"
                            focusable="false"
                            className="svg-inline--fa fa-star fv-rating__star svelte-1ipid5s"
                            viewBox="0 0 576 512"
                          >
                            <path
                              fill="currentColor"
                              d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                            ></path>
                          </svg>
                        </span>{" "}
                      </div>
                    </div>
                  </div>
                  <div className="reason astro-2srdwj4y">
                    Eine riesengroße und fantastische Ausstellung!
                  </div>
                </li>
              </ul>
              <div
                className="plan-user-reviews__actions astro-2srdwj4y"
                data-testid="plan-user-reviews-actions"
              >
                {" "}
                <a
                  href="/m/192454/reviews"
                  data-reviews-cta=""
                  data-reviews-cta-plan-id={192454}
                  data-reviews-cta-plan-name="The Art of the Brick: Eine LEGO® Kunstausstellung"
                  data-use-query-params=""
                  className="ignt-button ignt-button--small ignt-button--fill ignt-button--sharp-secondary astro-2srdwj4y svelte-16cc14r"
                  role="button"
                >
                  <span className="svelte-16cc14r">
                    {" "}
                    Alle Bewertungen anzeigen{" "}
                  </span>{" "}
                </a>{" "}
              </div>
            </div>
          </section>
          {/* Rating */}
          {/*
      <section class="plan-content__block svelte-b3darg" data-testid="plan-content-help">
        <h2 class="plan-content__block-title svelte-1w2y8p7"> <svg xmlns="http://www.w3.org/2000/svg" role="img"
            aria-hidden="true" focusable="false" class="svg-inline--fa fa-circle-question svelte-1ipid5s"
            viewBox="0 0 512 512">
            <path fill="currentColor"
              d="M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm168.7-86.2c6.5-24.6 28.7-41.8 54.2-41.8H280c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L272 268.3V288c0 8.8-7.2 16-16 16s-16-7.2-16-16V258.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3H222.9c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM232 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z">
            </path>
          </svg> Brauchst du Hilfe? </h2> Kontakt&nbsp;
      </section>
      <section class="plan-content__block svelte-b3darg">
        <h2 class="plan-content__block-title svelte-1w2y8p7"> <svg xmlns="http://www.w3.org/2000/svg" role="img"
            aria-hidden="true" focusable="false"
            class="svg-inline--fa fa-building-columns astro-alrzhy67 svelte-1ipid5s" viewBox="0 0 512 512">
            <path fill="currentColor"
              d="M263.9 2.1C259-.7 253-.7 248.1 2.1L15.8 133.7C6 139.3 0 149.6 0 160.8C0 178 14 192 31.2 192H256 480.8c17.2 0 31.2-14 31.2-31.2c0-11.2-6-21.6-15.8-27.1L263.9 2.1zM306.6 160c3.5-7.3 5.4-15.4 5.4-24c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 8.6 1.9 16.7 5.4 24H34.3L256 34.4 477.7 160H306.6zM256 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM64 352c-8.8 0-16 7.2-16 16s7.2 16 16 16H448c8.8 0 16-7.2 16-16s-7.2-16-16-16V224H416V352H336V224H304V352H208V224H176V352H96V224H64V352zM40 416c-8.8 0-16 7.2-16 16s7.2 16 16 16H472c8.8 0 16-7.2 16-16s-7.2-16-16-16H40zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z">
            </path>
          </svg> Über den Veranstaltungsort </h2>
        <div class="plan-venue astro-alrzhy67" data-testid="plan-place-preview">
          <div class="plan-venue__gallery astro-alrzhy67">
            <div class="plan-venue__gallery-slideshow astro-alrzhy67"> 
           </div>
          </div>
        </div>
      </section>
      */}
          {/* <section className="plan-content__block plan-content__block--hide-mobile svelte-b3darg">
            <div className="plan-location" data-testid="plan-location">
              <div className="plan-location__data auto">
                <h2 className="plan-content__block-title svelte-1w2y8p7">
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    role="img"
                    aria-hidden="true"
                    focusable="false"
                    className="svg-inline--fa fa-location-dot svelte-1ipid5s"
                    viewBox="0 0 384 512"
                  >
                    <path
                      fill="currentColor"
                      d="M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-240 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"
                    ></path>
                  </svg>{" "}
                  Anreise{" "}
                </h2>
              </div>
            </div>
          </section> */}
        </div>
        {/* Begin Time Picker*/}
        <TicketPicker/>
      </div>
    </div>
        </>
    )
}
export default MainContent;